module.exports = __webpack_public_path__ + "img/thumbnail_LarGibbon_f_erythristic.c4adadcc.png";